import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Reveal, { EASE, Eyebrow } from "./Reveal";
import { Wash, Sprig } from "./Watercolor";

export default function Collection({ products, onOrder }) {
  return (
    <section id="collection" className="relative py-24 sm:py-28" data-testid="collection-section">
      <Wash color="#FFECD1" size={560} opacity={0.5} className="top-24 -right-40" />
      <Wash color="#F472B6" size={400} opacity={0.2} className="-bottom-10 -left-32" />
      <Sprig color="#F472B6" className="hidden lg:block -top-10 right-[5%] w-28" />
      <Sprig color="#FFD166" leaf="#A3B18A" flip className="hidden lg:block bottom-12 left-[3%] w-24" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>The Collection — Batch Nº 07</Eyebrow>
          <div className="mt-4 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <h2 className="font-serif font-medium tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl max-w-xl">
              Nine umbrellas, zero chance of blending in.
            </h2>
            <p className="max-w-sm text-ink/70 leading-relaxed">
              Every piece is one of a kind — when it's gone, it's gone. Tap "order this one"
              and we'll reply with a sketch and a quote.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 sm:gap-10">
          {products.map((p, i) => (
            <motion.article
              key={p.id}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: EASE }}
              className="group flex h-full flex-col"
              data-testid={`product-card-${p.id}`}
            >
              <div className="relative overflow-hidden rounded-3xl aspect-[4/5] bg-peach">
                <img
                  src={p.image}
                  alt={p.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  data-testid={`product-image-${p.id}`}
                />
                <span className="absolute top-4 left-4 rounded-full bg-cream/90 backdrop-blur px-3 py-1.5 font-mono text-[10px] uppercase tracking-wider text-ink/70">
                  {p.category}
                </span>
              </div>
              <div className="flex items-start justify-between gap-4 pt-5">
                <h3 className="font-serif text-xl sm:text-2xl tracking-tight">{p.name}</h3>
                <span className="font-mono text-sm font-semibold text-terracotta pt-1.5" data-testid={`product-price-${p.id}`}>
                  ${p.price}
                </span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-ink/65">{p.description}</p>
              <div className="mt-4 pt-2 mt-auto">
                <button
                  data-testid={`order-btn-${p.id}`}
                  onClick={() => onOrder(p.name)}
                  className="inline-flex items-center gap-1.5 rounded-full border-2 border-ink/12 px-5 py-2.5 text-sm font-semibold text-ink transition-all hover:border-terracotta hover:bg-terracotta hover:text-white"
                >
                  Order this one
                  <ArrowUpRight size={15} />
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
